import { AutogenModelCorrIndQuickInfo, AutogenRowCorrIndQuickInfo } from "./autogen/AutogenModelCorrIndQuickInfo";

export class ModelCorrIndQuickInfo extends AutogenModelCorrIndQuickInfo<RowCorrIndQuickInfo> {
	constructor() {
		super(RowCorrIndQuickInfo);
	}
}

export class RowCorrIndQuickInfo extends AutogenRowCorrIndQuickInfo {
}